module.exports = __webpack_public_path__ + "static/img/hotelmeister-logo-autumn.8488d37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/png/hotelmeister-logo-autumn.png
// module id = L9vP
// module chunks = 0